module.exports = __webpack_public_path__ + "img/primary_8x1.6e5e4421.svg";